module.exports = __webpack_public_path__ + "static/media/add-icons.3c86bfbf.svg";